import { Component, ErrorInfo, ReactNode } from 'react';

type ErrorBoundaryProps = {
  fallback: (error?: Error) => ReactNode;
};

type ErrorBoundaryState = {
  error?: Error;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = { error: undefined };

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
      console.error(error);
    }

    this.setState({ error });
  }

  render() {
    const { children, fallback } = this.props;
    const { error } = this.state;

    return error ? fallback(error) : children;
  }
}

export { ErrorBoundary };
